/* eslint-disable max-len */
// Import dependencies
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useQuery, gql } from '@apollo/client';

// Import Image
import Loader from '../../../../../web/images/svg/loader.svg';

// Components
import CardListing from '../CardListing';

const GET_NEWS_LIST = gql`
  query backstage($limit: Int = null, $offset: Int = 0, $contentCategoryIds: [QueryArgument] = null) {
    entries (section: "backstageNews", limit: $limit, offset: $offset, relatedTo: $contentCategoryIds, orderBy: "date DESC") {
      title
      ... on backstageNews_backstageNews_Entry {
        id,
        description
        date
        url
        contentCategory {
          id
          title
        }
        imageListing {
          url @transform (width: 300, immediately: true)
        }
      }
    },
    categories: categories (group: "contentCategory", orderBy: "title ASC") {
      title
      id
    }
  }
`;

const NewsList = ({ limit, offset, contentCategoryIds }) => {
  const {
    loading,
    error,
    data,
    refetch,
    fetchMore,
  } = useQuery(GET_NEWS_LIST, {
    variables: {
      limit,
      offset,
      contentCategoryIds,
    },
  });

  const loadMore = useCallback(() => {
    fetchMore({
      variables: {
        offset: data && data.entries ? data.entries.length : 0,
      },
    });
  }, [fetchMore, data]);

  const onFilterChange = useCallback(() => {
    const checkboxes = document.getElementsByName('card-show-filter');
    const checkboxesMobile = document.getElementsByName('card-show-filter-mobile');
    const checkedValues = [];

    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        checkedValues.push(parseInt(checkbox.value, 10));
      }
    });

    // set the value also for the mobile checkboxes
    checkboxesMobile.forEach((checkbox) => {
      if (checkedValues.includes(parseInt(checkbox.value, 10))) {
        checkbox.checked = true;
      } else {
        checkbox.checked = false;
      }
    });

    refetch({
      contentCategoryIds: checkedValues.length > 0 ? checkedValues : null,
    });
  }, [refetch]);

  if (error) return <div>Error!</div>;
  if (loading) return <div className="c-loader  c-loader--absolute"><Loader /></div>;

  return (
    <CardListing
      entries={data.entries}
      totalEntries={data.totalEntries}
      categories={data.categories}
      onFilterChange={onFilterChange}
      onLoadMore={loadMore}
      initialLimit={limit}
    />
  );
};

NewsList.propTypes = {
  limit: PropTypes.number,
  offset: PropTypes.number,
  contentCategoryIds: PropTypes.array,
};

NewsList.defaultProps = {
  limit: 8,
  offset: 0,
  contentCategoryIds: null,
};

export default NewsList;
